<template>
  <section>
    <div class="pop-room" v-if="meetingInfoStatus">
      <a href="javascript:;" @click="closeMeetingInfo()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="23" v-if="meetingInfo">
          <el-form ref="form" label-width="100px" class="form" style="padding-top:0;">
            <el-form-item label="会议名称:">
              {{meetingInfo.name}}
              <span class="span-tip">{{meetingInfo.status}}</span>
            </el-form-item>
            <el-form-item label="会议时间:">
              {{meetingInfo.conferenceTime}}
            </el-form-item>
            <el-form-item label="会议地点:">
              {{meetingInfo.depName+' - '+meetingInfo.address}}
            </el-form-item>
            <el-form-item label="参会人员:">
              <div class="user-list" v-html="getUserList(meetingInfo.joinUsers, true)"></div>
            </el-form-item>
            <el-form-item label="会议资料:" v-if="meetingInfo.attachments">
              <p style="border-bottom:1px #ccc dashed;" v-for="item,i in meetingInfo.attachments">
                <file-link :item="item"></file-link>
                <a :href="item.fileUrl" style="margin-left:5px;" target="_blank">
                  <i class="el-icon-download meeting-name-icon"></i>
                </a>
              </p>
            </el-form-item>
            <el-form-item label="会议要求:" v-if="meetingInfo.req">
              {{meetingInfo.req}}
            </el-form-item>

            <div class="meeting-plan" v-if="meetingInfo.conferencePlan">
              <h4>会议准备</h4>
              <span class="plan-item" v-if="meetingInfo.conferencePlan.isHaveCamera">需要摄像</span>
              <span class="plan-item" v-if="meetingInfo.conferencePlan.isHaveTea">需要茶水</span>
              <span class="plan-item" v-if="meetingInfo.conferencePlan.isHaveEat">需要就餐</span>
              <span class="plan-item" v-if="meetingInfo.conferencePlan.isHaveProjector">需要投影</span>
              <span class="plan-item" v-if="meetingInfo.conferencePlan.isHaveSeat">需要座位牌</span>
              <p v-if="meetingInfo.conferencePlan.seat">座位牌安排:{{meetingInfo.conferencePlan.seat}}</p>
              <p v-if="meetingInfo.conferencePlan.remark">备注:{{meetingInfo.conferencePlan.remark}}</p>
            </div>

            <el-form-item label="会议纪要:" v-if="meetingInfo.summaryVO&&meetingInfo.summaryVO.files.length>0">
              <p style="border-bottom:1px #ccc dashed;" v-for="item,i in meetingInfo.summaryVO.files">
                <file-link :item="item.attachment"></file-link>
                <a :href="item.attachment.fileUrl" style="margin-left:5px;" target="_blank">
                  <i class="el-icon-download meeting-name-icon"></i>
                </a>
              </p>
            </el-form-item>
            <el-form-item label="关联项目:" v-if="meetingInfo.summaryVO&&meetingInfo.summaryVO.projects.length>0">
              <div class="person-room">
                <span class="persion-item" v-for="p,i in meetingInfo.summaryVO.projects">
                  {{p.name}}
                </span>
              </div>
            </el-form-item>

          </el-form>
        </el-col>
        <div class="ball-loading" v-else>
          <div class="k-ball-holder3">
            <div class="k-ball7a"></div>
            <div class="k-ball7b"></div>
            <div class="k-ball7c"></div>
            <div class="k-ball7d"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";


  import meetingMixin from '@/Mixins/meetingMixin'
  export default {
    mixins: [meetingMixin],
    props: ['meetingId', 'meetingInfoStatus'],
    computed: {
      ...mapState({
        // contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    components: {},
    data() {
      return {
        // 会议资料详情
        // meetingInfoStatus: false,

        meetingInfo: "",
        // 会议纪要详情
        summaryInfo: {},
      }
    },
    created() {},
    mounted() {
      this.getMeetingInfo()
    },
    methods: {
      // 获取参会人员
      getUserList(users, type) {
        if (!users) {
          return
        }
        let _item = ""
        let max = 3
        let _length
        if (!type) {
          _length = users.length > max ? max : users.length
        } else {
          _length = users.length
        }

        for (var i = 0; i < _length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 关闭弹窗
      closeMeetingInfo() {
        this.meetingInfo = ""
        this.$emit("hideMeetingInfo")
      },
      // 获取会议资料
      getMeetingInfo() {
        this.meetingInfoStatus = true
        ajax.get('/conference/detail/' + this.meetingId, '', (res) => {
          this.meetingInfo = res.vo
        })
      },
    },
    watch: {}
  }
</script>


// WEBPACK FOOTER //
// src/components/MeetingInfo.vue